import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';

const DividerTopContainer = styled.div`
  grid-area: topdivider;
  border-bottom: 1px solid #eee;
`;

const DividerTop = () => {
  return <DividerTopContainer />;
};

export default DividerTop;
